import BaseCellHandler from './BaseCellHandler';
import TextSamplesWrapper from '@/views/storyboard/charts/textsamples/TextSamplesWrapper';
import {TextSamplesChartData} from 'entities/chartData';


class TextSamplesCellHandler extends BaseCellHandler {
    endpointUrl = window.URLS.getTextSamples;

    renderContent() {
        const {data, queryDuration} = this.state;
        const {chartQuery, previewOnly, chartSettingsView} = this.props;

        return (
            <TextSamplesWrapper
                data={data as TextSamplesChartData[]}
                fieldToQuery={chartQuery.fields_to_query}
                previewOnly={previewOnly}
                queryDuration={queryDuration}
                chartSettingsView={chartSettingsView}
            />
        );
    }
}

export default TextSamplesCellHandler;
